import { AgmMap } from '@agm/core'
import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
@Component({
  selector: 'app-google-maps',
  templateUrl: './google-maps.component.html',
  styleUrls: ['./google-maps.component.scss'],
})
export class GoogleMapsComponent implements OnChanges {
  @ViewChild('AgmMap') agmMap: AgmMap
  @Input() points: { lat: number; lng: number }[]
  zoom: number = 16
  center: { lat: number; lng: number }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.points) {
      this.center = this.points[0]
    }
  }
}
